import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_DOCUMENT} from '../../constants';

export default {
  id: 'SIGN_ELEC',
  title: 'Comment signer électroniquement un document ?',
  description: '',
  categories: [CONTENT_CATEGORY_DOCUMENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Cliquez sur « Signer » à droite du document concerné'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_SIGN_ELEC/FR_SIGN_ELEC_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'La prévisualisation de votre document à signer s’affiche'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Acceptez le document en cochant la case « J’ai lu et j’accepte le document ci-dessus »'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_SIGN_ELEC/FR_SIGN_ELEC_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Renseignez le code à usage unique reçu par SMS.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: '(!) le code est automatiquement envoyé sur le mobile du signataire renseigné à l’inscription'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_SIGN_ELEC/FR_SIGN_ELEC_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '5.',
    value: 'Cochez les CGU, les CSU et la PPDP'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_SIGN_ELEC/FR_SIGN_ELEC_4.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '6.',
    value: 'Signez !'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_SIGN_ELEC/FR_SIGN_ELEC_5.png`
  }]
};
